// extracted by mini-css-extract-plugin
module.exports = {"preloaderWrap":"styles_preloaderWrap___1AKJ","preloader":"styles_preloader__pZPDs"};